import { Component, computed, inject, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalLayoutComponent } from "../modal-layout/modal-layout.component";
import { ButtonComponent } from '../../button/button.component';
import { LookupViewModel, SubmissionSummaryViewModel, ViewSubmissionStore } from '@program-suite/data-common';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';


@Component({
  selector: 'lib-loss-runs-request-detail',
  imports: [CommonModule, ModalLayoutComponent, ButtonComponent],
  templateUrl: './loss-runs-request-detail.component.html',
  styleUrl: './loss-runs-request-detail.component.scss',
})
export class LossRunsRequestDetailComponent  {
    data = inject(MAT_DIALOG_DATA) as any;
    dialogRef = inject(MatDialogRef<LossRunsRequestDetailComponent>);
   viewSubmissionStore = inject(ViewSubmissionStore);

     download(lossRunsRequestGuid: string) {
      this.viewSubmissionStore.downloadLossRun(lossRunsRequestGuid);
      this.dialogRef.close();
  }
}



